import { bootstrapApplication } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { takeReloadTarget } from './app/core/errors/chunk-load-error';

bootstrapApplication(AppComponent, appConfig)
  .then((appRef) => {
    // A stale chunk forced a reload; finish the navigation the user started.
    const target = takeReloadTarget();
    if (target) void appRef.injector.get(Router).navigateByUrl(target);
  })
  .catch((err) => console.error(err));
